import { useCallback } from 'react';
import { TileLayer } from 'react-leaflet';

function useDynamicTileLayer(url: string) {
  return useCallback(() => <TileLayer url={url} />, [url]);
}

export default useDynamicTileLayer;
